const FACET_CODES = {
  MANUFACTURER: 'facet-manufacturerNames',
  CHUCK_TYPE: 'Facet_FUTTER_TYP',
  CHUCK_SIZE: 'Facet_FUTTER_GROESSE',
  CHUCK_DETAIL: 'Facet_FUTTER_DETAILS'
};

export default FACET_CODES;



// WEBPACK FOOTER //
// ./src/constants/facetCodes.js